import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validador que impede que o campo contenha apenas espaços em branco
 * @returns ValidatorFn que retorna erro se o valor for apenas espaços em branco
 */
export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = control.value.toString().trim();
    
    if (value === '') {
      return { whitespace: true };
    }

    return null;
  };
}
